"use client"
import { Heading } from "@/components/ui/Heading";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { useRouter } from "next/navigation";

const CustomButton = loadThemeComponent("CustomButton")


export default function NotFound() {
  const { dictionary } = useDictionary();
  const router = useRouter()

  return (
    <div className="flex min-h-[calc(100vh-72px)]">
      <div className="m-auto max-w-1/2 bg-primary-0 border-primary-300 flex items-center justify-between rounded-md border p-4">
        <div className="text-center p-10 max-w-md m-auto">
          <Heading>
            {dictionary.ui.notFound.title}
          </Heading>
          <p className="text-primary-800 mb-6 mt-2">
            {dictionary.ui.notFound.subtitle}
          </p>
          <CustomButton
            onClick={router.back}
          >
            {dictionary.ui.notFound.back}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}